import { render, staticRenderFns } from "./wallet_agent.vue?vue&type=template&id=10b5a90b"
import script from "./wallet_agent.vue?vue&type=script&lang=js"
export * from "./wallet_agent.vue?vue&type=script&lang=js"
import style0 from "./wallet_agent.vue?vue&type=style&index=0&id=10b5a90b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports